/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import {Component, OnDestroy, ViewEncapsulation, ElementRef} from "@angular/core";
import {ICellRendererAngularComp} from "ag-grid-angular";

@Component({
    template: `
    <div class="col-md-12 genealogy-level-access-slider">
        <input type='number' [(ngModel)]="params.value" step ="1" min='0' class="col-sm-3 width-12 input-number–styledSpinners" (keyup)="inputKeyUp($event)" (ngModelChange)="modelChanged($event)"/>
        <div class="col-sm-8 no-padding">
            <span class="slider-label min-label">0</span>
            <p-slider [(ngModel)]="params.value" [min]="0" [max]="sliderMaxValue" [style]="{'width':'35rem'}" (onChange)="sliderValueChanged($event)"></p-slider>
            <span class="slider-label max-label">20+</span>
        </div>
        
    </div>
    `,
    styles:[ `
        p-slider{
            display:inline-block;
        }
        .ui-slider{
            background: #f5f5f5;
            height: 1px;
            border: solid 3px rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            box-shadow:none;
        }
        .ui-slider .ui-slider-range{
            background: #0a6ed1 !important;
            height: 6px;
            position: relative;
            top: -2px;
            border-radius: 3px;
            left: -2px;
            box-shadow: none;
        }
        .ui-slider-horizontal .ui-slider-handle{
            top: -1.2rem !important;
        }
        .ui-slider .ui-slider-handle{
            width: 2.3rem !important;
            height: 2.3rem !important;
            cursor: default;
            outline: none;
            border-radius: 50%;
            border: none;
            background: #0a6ed1 !important;
            font-size: 1.2rem;
            text-align: center;
            color: rgb(255, 255, 255);
            font-family: 'Open Sans Condensed', sans-serif; 
            font-stretch: condensed;
        }
        .input-number–styledSpinners{
            width: 7rem;
            margin-right:1rem;
            height:2.6rem !important;
            margin-top:0.2rem;
        }
        .slider-label{
            font-family: 'Open Sans Condensed', sans-serif; 
            font-stretch: condensed;
            font-size: 1.2rem;
            color: rgba(0, 0, 0, 0.4)
        }
        .min-label{
            margin-right:2rem;
        }
        .max-label{
            margin-left:2rem;
        }
    `],
    encapsulation: ViewEncapsulation.None
})
export class PermissionsLevelAccessSliderRender implements ICellRendererAngularComp, OnDestroy {
    public params: any;
    public sliderHandleEle: any;
    public sliderRangeEle: any;
    public sliderMaxValue!: number;
    
    constructor(private el: ElementRef) {
    }

    agInit(params: any): void {
        this.params = params;
        this.sliderMaxValue = 20;
    }

    // ngAfterViewInit() {
    //     /* Inserting Access Level value to sliderHandle (circle) through DOM Manuplation */
    //     this.sliderHandleEle = new ElementRef(this.el.nativeElement.querySelector('.ui-slider-handle'));
    //     this.sliderHandleEle.nativeElement.innerText = this.params.value;

    //     /* Inserting Blue Color Progress slider range through DOM Manuplation */
    //     const uiSlderEleRef = new ElementRef(this.el.nativeElement.querySelector('.ui-slider')),
    //           span = document.createElement("span");
    //     span.className = "ui-slider-range";
    //     uiSlderEleRef.nativeElement.appendChild(span);
    //     this.sliderRangeEle = new ElementRef(this.el.nativeElement.querySelector('.ui-slider-range'));

    //     /* Calculating slider range width based on input filed value */
    //     this.calculateSliderRangeWidth();

    //   }
    agAfterGuiAttached(): void {
        setTimeout(() => {
            this.sliderHandleEle = new ElementRef(this.el.nativeElement.querySelector('.ui-slider-handle'));
            if (this.sliderHandleEle?.nativeElement) {
                this.sliderHandleEle.nativeElement.innerText = this.params.value;

                const uiSliderEleRef = new ElementRef(this.el.nativeElement.querySelector('.ui-slider'));
                const span = document.createElement("span");
                span.className = "ui-slider-range";
                uiSliderEleRef.nativeElement.appendChild(span);

                this.sliderRangeEle = new ElementRef(this.el.nativeElement.querySelector('.ui-slider-range'));
                this.calculateSliderRangeWidth();
            }
        });
    }

    ngOnDestroy() {
    }
    
    public calculateSliderRangeWidth() {
        if (!this.sliderRangeEle?.nativeElement) return;

        let range = (this.params.value / this.sliderMaxValue) * 100;
        range = (range > 100) ? 100 : range;
        this.sliderRangeEle.nativeElement.style.width = range + "%";
    }

    public modelChanged(event: any) {
        this.params.data.level = event;
        if (this.sliderHandleEle?.nativeElement) {
            this.sliderHandleEle.nativeElement.innerText = this.params.value;
        }
        this.calculateSliderRangeWidth();
        // this.params.context.componentParent.userGroupsForm.form.markAsDirty();
    }

    public sliderValueChanged(event: any) {
        this.params.data.level = event.value;
        if (this.sliderHandleEle?.nativeElement) {
            this.sliderHandleEle.nativeElement.innerText = this.params.value;
            this.sliderRangeEle.nativeElement.style.width = this.sliderHandleEle.nativeElement.style.left;
        }
        // this.params.context.componentParent.userGroupsForm.form.markAsDirty();
    }

    public inputKeyUp(event: any){
        this.params.value = this.params.value < 0 ? 0 : this.params.value;
        this.sliderHandleEle.nativeElement.innerText = this.params.value;
    }
    
    public refresh(): boolean {
        return false;
    }
}